import { CalendarRoot } from "PFApp/booking/types/calendar_root";
import { CalendarRange, Filters, Value } from "PFTypes";

export const rowChildrenKeys = {
  all: () => ["rowChildren"],
  ofRow: (
    calendarRoot: CalendarRoot,
    rowKey: string,
    childrenType: "activity" | "role" | "profile",
    dateRange: CalendarRange,
    filters: Filters<Value> | undefined,
    perPage: number | null,
    page: number | null
  ) => [...rowChildrenKeys.all(), calendarRoot, rowKey, childrenType, dateRange, filters, perPage, page],
  isRowChildrenQuery: (query) => query.queryKey[0] === "rowChildren"
};
